export const useAccordionWcag = () => {
  const resetWcagAttributes = {
    "aria-expanded": undefined,
    "aria-disabled": undefined,
    tabIndex: -1,
    role: undefined
  };

  const createWcagAttributes = ({
    expanded,
    disabled = false,
  }: {
    expanded: boolean;
    disabled?: boolean;
  }) => ({
    "aria-expanded": expanded,
    "aria-disabled": disabled,
    tabIndex: 0,
    role: "button",
  });

  return {
    resetWcagAttributes,
    createWcagAttributes,
  };
};
